<template>
     <div>
            <section>
                <div class="container">
                    <div class="row d-flex justify-content-center">
                        <div class="col-md-10 text-center">
                            <h2 class="textos subtitulos-intermedios azul bold py-4">ELLOS PONEN SU TRANQUILIDAD EN NUESTRAS MANOS</h2>
                        </div>
                    </div>
                </div>
            </section>

              <section id="section-clientes" class='my-4'>
                <div class="container">

                    <!-- Carousel Start -->
                    <agile :initial-slide="0" :autoplay="true" :centerMode="true" :navButtons="false" :dots="false">
                        <div class="slide">
                            <div class="row justify-content-center">
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/1.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/2.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/3.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/4.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/5.png" class="img-fluid img-fluid2" alt="">
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/6.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/7.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/8.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/9.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/10.png" class="img-fluid img-fluid2" alt="">
                                </div>

                            </div>
                        </div>
                        <div class="slide">
                            <div class="row justify-content-center">
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/11.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/12.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/13.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/14.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/15.png" class="img-fluid img-fluid2" alt="">
                                </div>
                            </div>
                            <div class="row justify-content-center">
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/16.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/17.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/18.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/19.png" class="img-fluid img-fluid2" alt="">
                                </div>
                                <div class="col-md-2 icons-clientes">
                                    <img src="../assets/template/clientes/20.png" class="img-fluid img-fluid2" alt="">
                                </div>

                            </div>
                        </div>


                        <template slot="prevButton">
                            <i class="fas fa-chevron-left"></i>
                        </template>
                        <template slot="nextButton">
                            <i class="fas fa-chevron-right"></i>
                        </template>
                    </agile>
                    <!-- Carousel End -->
                    <div class="row  pt-md-2  animate__animated animate__fadeInDown">
                        <div class="col-12 col-md-12 text-center pt-md-5 pt-3 animate__animated animate__pulse animate__infinite	infinite">
                          <router-link class="bg-rojo px-4 py-2 rounded-pill textos parrafos-principales regular blanco mayus" :to="{name: 'Clientes'}">ver clientes</router-link>
                        </div>
                    </div>
                </div>

            </section>
            <Footer />
        </div>
</template>
<style>
    @import "../assets/template/css/HSectionNum.css";
    @import "../assets/template/css/Home.css";
    @import "../assets/template/css/HomaMedia.css";
    @import "../assets/template/css/textosF.css";
    @import "../assets/template/css/Icons.css";
    @import "../assets/template/css/HSectionFrase.css";
    @import "../assets/template/css/HSectionMap.css";
    @import "../assets/template/css/NavMenu.css";
    @import "../assets/template/css/NavMenuMedia.css";
    @import "../assets/template/css/generals.css";

    .descansoImg {
        background-image: url("../assets/template/images/banner.png");
        background-attachment: fixed;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
    
    .numeraliaImg {
        background-image: url("../assets/template/images/fondo-numeralia.png");
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .iconosImg {
        background-image: url("../assets/template/images/fondo.png");
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .img-fluid2 {
        /*flex: 0 0 33.333333%;
        max-width: 33.333333%;*/
    }
    
</style>
<script>
    import { VueAgile } from 'vue-agile';

    export default {
        name: 'MyComponent',
        components: {
            agile: VueAgile,
        }
    }
    </script>